import produce from 'immer'
import { SeccionturismosAction, SeccionturismosActionTypes } from '../actions/seccionturismosActions'
import { ApiStatus, ISeccionturismosItem } from '../models'

export const initialSeccionturismosState: ISeccionturismosState = {
  loadingStatus: ApiStatus.NOTLOADED,
  addingStatus: ApiStatus.NOTLOADED,
  searchingStatus: ApiStatus.NOTLOADED,
  searchString: '',
  seccionturismos: [],
  foundseccionturismos: [],
  totalDocs: 0,
  errMessage: '',
  errStatus: null,
  errField: null,
}

export default function seccionturismosReducer(state: ISeccionturismosState = initialSeccionturismosState, action: SeccionturismosAction) {
  return produce(state, (draft) => {
    switch (action.type) {
      case SeccionturismosActionTypes.SEARCH_SECCIONTURISMOS:
        draft.searchString = action.searchOptions.searchString
        break
      case SeccionturismosActionTypes.SEARCHING_SECCIONTURISMOS:
        draft.searchingStatus = ApiStatus.LOADING
        draft.loadingStatus = ApiStatus.NOTLOADED
        draft.addingStatus = ApiStatus.NOTLOADED
        break

      case SeccionturismosActionTypes.SEARCHING_SECCIONTURISMOS_FAILED:
        draft.searchingStatus = ApiStatus.FAILED
        break

      case SeccionturismosActionTypes.FOUND_SECCIONTURISMOS:
        draft.searchingStatus = ApiStatus.LOADED
        action.keep
          ? draft.foundseccionturismos.push(...action.payload.seccionturismos.docs)
          : (draft.foundseccionturismos = action.payload.seccionturismos.docs)
        draft.totalDocs = action.payload.seccionturismos.totalDocs
        break

      case SeccionturismosActionTypes.LOAD_SECCIONTURISMOS:
      case SeccionturismosActionTypes.LOADING_SECCIONTURISMOS:
        draft.loadingStatus = ApiStatus.LOADING
        draft.addingStatus = ApiStatus.NOTLOADED
        draft.searchingStatus = ApiStatus.NOTLOADED
        draft.foundseccionturismos = []
        break

      case SeccionturismosActionTypes.LOADING_SECCIONTURISMOS_FAILED:
        draft.loadingStatus = ApiStatus.FAILED
        break

      case SeccionturismosActionTypes.LOADED_SECCIONTURISMOS:
        draft.loadingStatus = ApiStatus.LOADED
        draft.seccionturismos = action.payload.seccionturismos.docs
        draft.totalDocs = action.payload.seccionturismos.totalDocs
        break

      case SeccionturismosActionTypes.ADD_SECCIONTURISMOS:
      case SeccionturismosActionTypes.ADDING_SECCIONTURISMOS:
        draft.addingStatus = ApiStatus.LOADING
        draft.searchingStatus = ApiStatus.NOTLOADED
        draft.errMessage = ''
        draft.errStatus = null
        draft.errField = null
        break

      case SeccionturismosActionTypes.ADDING_SECCIONTURISMOS_FAILED:
        draft.addingStatus = ApiStatus.FAILED
        draft.errMessage = action.message
        draft.errStatus = action.status
        draft.errField = action.field
        break

      case SeccionturismosActionTypes.ADDED_SECCIONTURISMOS:
        draft.addingStatus = ApiStatus.LOADED
        draft.errStatus = 200
        draft.seccionturismos.push(action.payload.seccionturismos.docs[0])
        if (draft.searchString) draft.foundseccionturismos.push(action.payload.seccionturismos.docs[0])
        break

      case SeccionturismosActionTypes.REMOVE_SECCIONTURISMO:
        draft.seccionturismos.splice(
          draft.seccionturismos.findIndex((seccionturismo) => seccionturismo._id === action.payload._id),
          1
        )
        break

      case SeccionturismosActionTypes.SOFT_REMOVE_SECCIONTURISMOS:
        draft.loadingStatus = ApiStatus.NOTLOADED
        draft.addingStatus = ApiStatus.LOADING
        break

      case SeccionturismosActionTypes.SOFT_REMOVING_SECCIONTURISMOS:
        draft.loadingStatus = ApiStatus.LOADING
        draft.addingStatus = ApiStatus.LOADING
        break

      case SeccionturismosActionTypes.SOFT_REMOVED_SECCIONTURISMOS:
        draft.addingStatus = ApiStatus.LOADED
        draft.seccionturismos.splice(
          draft.seccionturismos.findIndex((seccionturismo) => seccionturismo._id === action.payload._id),
          1
        )
        break

      case SeccionturismosActionTypes.SOFT_REMOVING_SECCIONTURISMOS_FAILED:
        draft.addingStatus = ApiStatus.FAILED
        draft.errMessage = action.message
        draft.errStatus = action.status
        draft.errField = action.field
        break

      case SeccionturismosActionTypes.EDIT_SECCIONTURISMOS:
        draft.loadingStatus = ApiStatus.NOTLOADED
        draft.addingStatus = ApiStatus.LOADING
        draft.searchingStatus = ApiStatus.NOTLOADED
        break

      case SeccionturismosActionTypes.EDITING_SECCIONTURISMOS:
        draft.loadingStatus = ApiStatus.LOADING
        draft.addingStatus = ApiStatus.LOADING
        break

      case SeccionturismosActionTypes.EDITED_SECCIONTURISMOS:
        draft.addingStatus = ApiStatus.LOADED
        draft.seccionturismos[draft.seccionturismos.findIndex((seccionturismo) => seccionturismo._id === action.payload._id)] = action.payload
        draft.foundseccionturismos[draft.foundseccionturismos.findIndex((seccionturismo) => seccionturismo._id === action.payload._id)] =
          action.payload
        break

      case SeccionturismosActionTypes.EDITING_SECCIONTURISMOS_FAILED:
        draft.addingStatus = ApiStatus.FAILED
        draft.errMessage = action.message
        draft.errStatus = action.status
        draft.errField = action.field
        break
    }
  })
}

export interface ISeccionturismosState {
  loadingStatus: ApiStatus
  addingStatus: ApiStatus
  searchingStatus: ApiStatus
  searchString: string
  seccionturismos: ISeccionturismosItem[]
  foundseccionturismos: ISeccionturismosItem[]
  totalDocs: number
  errMessage?: string
  errStatus?: number
  errField?: string
}
